import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";

import { DefaultHeaderCell, DropdownHeaderCell } from "../../../Layout/SortedList";
import IdTypes from "../../IdTypes";

class RollsListHeader extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    onDropdownClick: PropTypes.func.isRequired,
    selectedKeyById: PropTypes.string.isRequired,
    sort: PropTypes.object
  };

  static defaultProps = {
    sort: {}
  };

  getListHeaderDropdownItems = () => {
    const { selectedKeyById } = this.props;
    const label = i18n.t(`rolls.${selectedKeyById === IdTypes.tappiId ? IdTypes.ifraId : IdTypes.tappiId}`);

    return [
      {
        onClick: e => {
          e.stopPropagation();
          this.props.onDropdownClick();
        },
        label
      }
    ];
  };

  handleClick = keyName => this.props.onClick(keyName);

  render() {
    const dropdownItems = this.getListHeaderDropdownItems();

    return (
      <div role="row" tabIndex="0" className="sorted-list__row-header">
        <DropdownHeaderCell
          className="--first --x3"
          dropdownItems={dropdownItems}
          keyName="tappiId"
          label={i18n.t(`rolls.${this.props.selectedKeyById}`)}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--x4"
          keyName="productName"
          label={i18n.t("rolls.product")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--x3"
          keyName="dimension"
          label={i18n.t("rolls.dimensions")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--right --x2"
          keyName="grossWeight.value"
          label={i18n.t("rolls.shipped")}
          tooltipContent={i18n.t("tooltip.shipped")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--right --x2"
          keyName="rollLength.value"
          label={i18n.t("rolls.length")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--right --x2"
          keyName="rollSurface.value"
          label={i18n.t("rolls.surface")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--right --x1"
          keyName="rollsPerPack"
          label={i18n.t("rolls.rp")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--x3"
          keyName="productionDate"
          label={i18n.t("rolls.production")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
      </div>
    );
  }
}

export default RollsListHeader;



// WEBPACK FOOTER //
// ./src/components/BillOfLading/List/Rolls/RollsListHeader.js